import React from 'react';
import { SponsorButton, StarButton } from '#components';
import { Container, starBtnStyle, sponsorBtnStyle } from './AvatarTitle.styles';

export const AvatarTitle = ({ avatarUrl, title, style }) => (
  <Container style={style}>
    <div className="titleContainer">
      <img src={avatarUrl} alt="avatar" className="avatar" />
      <h4>{title}</h4>
    </div>
    <div className="buttonsContainer">
      <StarButton style={starBtnStyle} />
      <SponsorButton style={sponsorBtnStyle} />
    </div>
  </Container>
);
